import { IPromise } from 'angular';

export interface IMemoService {
  openMemoForm(
    responseId: string,
    disableAction: boolean,
    isRecipientListValid: boolean,
    deferAction: () => IPromise<unknown>,
    deferWithoutSendAction: () => void
  ): void;
}

export class MemoService implements IMemoService {
  static $inject: Array<string> = ['$uibModal'];

  constructor(private readonly $uibModal: any) {}

  openMemoForm(
    responseId: string,
    disableAction: boolean,
    isRecipientListValid: boolean,
    deferAction: () => IPromise<unknown>,
    deferWithoutSendAction: () => void
  ): void {
    this.$uibModal.open({
      component: 'memoPopup',
      keyboard: false,
      ariaLabelledBy: 'modal-header',
      ariaDescribedBy: 'modal-body',
      resolve: {
        responseId: () => responseId,
        isRecipientListValid: () => isRecipientListValid,
        disableAction: () => disableAction,
        deferAction: () => deferAction,
        deferWithoutSendAction: () => deferWithoutSendAction,
      },
    });
  }
}

export default 'memo';
